import React, {useEffect, useState} from 'react';
import { Box, Container, CssBaseline, Typography, TextField, Button, FormControlLabel, Checkbox, Link, Paper } from '@mui/material';
import LockOutIcon from '@mui/icons-material/LockOutlined';
import {executeJwtAuthenticationService} from '../../api/authenticateAPI';

function Login() {

    const [id, setId] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [remember, setRemember] = useState<boolean>(false);

    useEffect(() => {
        const savedId = localStorage.getItem('rememberId');
        if (savedId){
            setId(savedId);
            setRemember(true);
        }
    }, []);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        // const data: FormData = new FormData(event.currentTarget);
        // const id: FormDataEntryValue | null = data.get('id');
        // const password: FormDataEntryValue | null = data.get('password');

        if (id !== null && password !== null) {
            if (remember) {
              localStorage.setItem('rememberId', id);
            } else {
              localStorage.removeItem('rememberId');
            }

            executeJwtAuthenticationService(id, password).then(value => {
                if (value) {
                    window.location.reload();
                } else {
                    alert('인증에 실패하였습니다.')
                }
            })
        } else {
            alert('Empty value!')
        }
    };

    return (
        <Box
      sx={{
        backgroundColor: '#e8ebf0', // 💡 전체 배경색
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            borderRadius: 3,
            backgroundColor: '#fff', // 💡 로그인 박스 배경
          }}
        >
          <Typography
            component="h1"
            variant="h5"
            align="center"
            sx={{
              fontWeight: 'bold',
              mb: 3,
              borderBottom: '2px solid #ccc', // 💡 하단 선
              display: 'inline-block',
              pb: 1,
            }}
          >
            로그인
          </Typography>

          <Box component="form" onSubmit={handleSubmit} noValidate>
            {/* 💡 입력 필드를 테이블처럼 구성 */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Box sx={{ width: '80px', fontWeight: 'bold' }}>아이디</Box>
              <TextField
                size="small"
                required
                fullWidth
                id="id"
                name="id"
                value={id}
                autoComplete="username"
                onChange={e => setId(e.target.value)}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Box sx={{ width: '80px', fontWeight: 'bold' }}>비밀번호</Box>
              <TextField
                size="small"
                required
                fullWidth
                name="password"
                type="password"
                id="password"
                value={password}
                autoComplete="current-password"
                onChange={e => setPassword(e.target.value)}
              />
            </Box>

            {/* 💡 아이디 기억하기 체크박스 */}
            <FormControlLabel
              control={<Checkbox checked={remember} value="remember" color="primary"
                                onChange={(e) => setRemember(e.target.checked)}/>}
              label="아이디 기억하기"
              sx={{ mt: 1 }}
            />

            {/* 💡 로그인 버튼 */}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                backgroundColor: '#FF000070',
                color: 'primary',
                '&:hover': {
                  backgroundColor: '#FF000077',
                },
              }}
            >
              로그인
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
    );
}

export default Login;